import {endpoints} from './endpoints'
import request from '../request'

export function createUserRequest (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createUserRequest,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function acceptRejectUserRequest (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.acceptRejectUserRequest,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getUserRequests (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getUserRequests,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getUserRequestById (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getUserRequestById,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}